import { Image } from '@/components/client';

export const StaticBanner = () => {
  return (
    <section className="flex flex-col">
      {TOP_BANNER_IMAGE_URLS.map((image) => (
        <ImageSection
          key={image.url}
          imageUrl={image.url}
          alt={image.alt}
          title={image.title}
          description={image.description}
        />
      ))}
    </section>
  );
};

interface ImageSectionProps {
  imageUrl: string;
  alt: string;
  title: string;
  description: string;
}

const ImageSection = ({
  imageUrl,
  alt,
  title,
  description,
}: ImageSectionProps) => {
  return (
    <section className="flex flex-col">
      <h2 className="sr-only">{title}</h2>
      <p className="sr-only">{description}</p>
      <Image
        src={imageUrl}
        width={850}
        height={480}
        className="w-full"
        alt={alt}
      />
    </section>
  );
};

const TOP_BANNER_IMAGE_URLS = [
  {
    url: 'https://cdn.welfarehello.com/static/donation-gift-detail-notes.png',
    alt: '고향사랑기부 혜택 정보를 가르쳐주는 이미지',
    title: '10만원 기부하면, 전액 세액공제 받고, 3만원 답례품을 받아요',
    description:
      '소중한 기부금, 이렇게 사용돼요. 1.기부금은 해당 지자체로 바로 전달되어 주민 복리 증진 사엄에 사용돼요. 2. 각 지자체는 기부금 사용내역을 매년 2월 지자체 홈페이지에 투명하게 공개해요. 3. 고향사랑기부금법에 따라 지원금은 사회적 취약계층 지원과 청소년 육성 보호, 지역 주민 문화 예술 보건 증진, 지역 공동체 활성화 지원, 주민 복리증진 사업 등 정해진 용도로만 사용 가능해요. 참고하세요! 올해 이미 전액 환급 대상인 경우 올해는 고향사랑기부금 세액공제가 적용되지 않습니다. 다만, 해당 공제액은 사라지지 않고 최대 10년 동안 이월하여 공제 받을 수 있습니다.',
  },
];
